import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosResponse } from 'axios'
import { useMemo } from 'react'

export const useGetDailyConversion = (isNewAdvance: boolean = false): any => {
  let url = ''
  if (isNewAdvance) {
    url = `/producer/analytics/getAdvanceConvertion?isNewAdvance=true`
  } else {
    url = `/producer/analytics/getAdvanceConvertion?isNewAdvance=false`
  }
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      dailyConversion: nestedData,
      dailyConversionLoading: isLoading,
      dailyConversionError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}
